// Constantes pour les statuts d'opération Baobab Connect V2 (Workflow Simplifié)

// 14 statuts du workflow principal
export const STATUS_VALUES = {
  DEMANDE_ENREGISTREE: 'demande_enregistree',
  EN_ATTENTE_DE_DEVIS: 'en_attente_de_devis',
  EN_ATTENTE_VALIDATION_CLIENT: 'en_attente_validation_client',
  EN_NEGOCIATION: 'en_negociation',
  DEVIS_ACCEPTE: 'devis_accepte',
  PLANIFIEE: 'planifiee',
  PRETE_AU_CHARGEMENT: 'prete_au_chargement',
  EN_COURS_DE_CHARGEMENT: 'en_cours_de_chargement',
  CHARGE_EN_ROUTE: 'charge_en_route',
  LIVREE: 'livree',
  EN_ATTENTE_PAIEMENT: 'en_attente_paiement',
  PAYEE: 'payee',
  TERMINEE: 'terminee',
  ANNULEE_ADMIN: 'annulee_admin',
  ANNULEE_PAR_CLIENT: 'annulee_par_client',
  CANCELLED: 'cancelled',
  
  // Anciens statuts (rétrocompatibilité legacy data)
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
};

// Configuration complète des statuts - Version professionnelle sans emojis
// iconName correspond aux noms d'icônes Lucide-React
// dotColor pour indicateur minimaliste
export const STATUS_CONFIG = {
  [STATUS_VALUES.DEMANDE_ENREGISTREE]: {
    label: 'Demande enregistrée',
    shortLabel: 'Enregistrée',
    color: 'blue',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-800',
    dotColor: 'bg-blue-500',
    iconName: 'FileEdit',
    step: 1
  },
  [STATUS_VALUES.EN_ATTENTE_DE_DEVIS]: {
    label: 'En attente de devis',
    shortLabel: 'Attente devis',
    color: 'yellow',
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    dotColor: 'bg-amber-500',
    iconName: 'Clock',
    step: 2
  },
  [STATUS_VALUES.EN_ATTENTE_VALIDATION_CLIENT]: {
    label: 'En attente de validation client',
    shortLabel: 'Validation client',
    color: 'purple',
    bgColor: 'bg-purple-100',
    textColor: 'text-purple-800',
    dotColor: 'bg-purple-500',
    iconName: 'UserCheck',
    step: 3
  },
  [STATUS_VALUES.EN_NEGOCIATION]: {
    label: 'En négociation',
    shortLabel: 'Négociation',
    color: 'pink',
    bgColor: 'bg-pink-100',
    textColor: 'text-pink-800',
    dotColor: 'bg-pink-500',
    iconName: 'MessageSquare',
    step: 4
  },
  [STATUS_VALUES.DEVIS_ACCEPTE]: {
    label: 'Devis accepté',
    shortLabel: 'Accepté',
    color: 'teal',
    bgColor: 'bg-teal-100',
    textColor: 'text-teal-800',
    dotColor: 'bg-teal-500',
    iconName: 'CheckCircle',
    step: 5
  },
  [STATUS_VALUES.PLANIFIEE]: {
    label: 'Planifiée',
    shortLabel: 'Planifiée',
    color: 'cyan',
    bgColor: 'bg-cyan-100',
    textColor: 'text-cyan-800',
    dotColor: 'bg-cyan-500',
    iconName: 'Calendar',
    step: 6
  },
  [STATUS_VALUES.PRETE_AU_CHARGEMENT]: {
    label: 'Prête au chargement',
    shortLabel: 'Prête',
    color: 'indigo',
    bgColor: 'bg-indigo-100',
    textColor: 'text-indigo-800',
    dotColor: 'bg-indigo-500',
    iconName: 'CheckSquare',
    step: 7
  },
  [STATUS_VALUES.EN_COURS_DE_CHARGEMENT]: {
    label: 'En cours de chargement',
    shortLabel: 'Chargement',
    color: 'orange',
    bgColor: 'bg-orange-100',
    textColor: 'text-orange-800',
    dotColor: 'bg-orange-500',
    iconName: 'Package',
    step: 8
  },
  [STATUS_VALUES.CHARGE_EN_ROUTE]: {
    label: 'Chargé - En route',
    shortLabel: 'En route',
    color: 'blue',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-800',
    dotColor: 'bg-blue-500',
    iconName: 'Truck',
    step: 9
  },
  [STATUS_VALUES.LIVREE]: {
    label: 'Livrée',
    shortLabel: 'Livrée',
    color: 'green',
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
    dotColor: 'bg-green-500',
    iconName: 'CircleCheck',
    step: 10
  },
  [STATUS_VALUES.EN_ATTENTE_PAIEMENT]: {
    label: 'En attente de paiement',
    shortLabel: 'Attente paiement',
    color: 'amber',
    bgColor: 'bg-amber-100',
    textColor: 'text-amber-800',
    dotColor: 'bg-amber-500',
    iconName: 'CreditCard',
    step: 11
  },
  [STATUS_VALUES.PAYEE]: {
    label: 'Payée',
    shortLabel: 'Payée',
    color: 'emerald',
    bgColor: 'bg-emerald-100',
    textColor: 'text-emerald-800',
    dotColor: 'bg-emerald-500',
    iconName: 'BadgeCheck',
    step: 12
  },
  [STATUS_VALUES.TERMINEE]: {
    label: 'Terminée',
    shortLabel: 'Terminée',
    color: 'green',
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
    dotColor: 'bg-green-500',
    iconName: 'CheckCircle2',
    step: 13
  },
  [STATUS_VALUES.ANNULEE_ADMIN]: {
    label: 'Annulée par l\'administrateur',
    shortLabel: 'Annulée (Admin)',
    color: 'red',
    bgColor: 'bg-red-100',
    textColor: 'text-red-800',
    dotColor: 'bg-red-400',
    iconName: 'Ban',
    step: 0
  },
  [STATUS_VALUES.ANNULEE_PAR_CLIENT]: {
    label: 'Annulée par le client',
    shortLabel: 'Annulée (Client)',
    color: 'gray',
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-800',
    dotColor: 'bg-gray-400',
    iconName: 'XCircle',
    step: 0
  },
  [STATUS_VALUES.CANCELLED]: {
    label: 'Annulée',
    shortLabel: 'Annulée',
    color: 'red',
    bgColor: 'bg-red-100',
    textColor: 'text-red-800',
    dotColor: 'bg-red-400',
    iconName: 'XCircle',
    step: 0
  },
  
  // Anciens statuts (rétrocompatibilité)
  [STATUS_VALUES.PENDING]: {
    label: 'En attente',
    shortLabel: 'En attente',
    color: 'yellow',
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    dotColor: 'bg-amber-500',
    iconName: 'Clock',
    step: 0
  },
  [STATUS_VALUES.ACCEPTED]: {
    label: 'Accepté',
    shortLabel: 'Accepté',
    color: 'blue',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-800',
    dotColor: 'bg-blue-500',
    iconName: 'CheckCircle',
    step: 0
  },
  [STATUS_VALUES.IN_PROGRESS]: {
    label: 'En cours',
    shortLabel: 'En cours',
    color: 'purple',
    bgColor: 'bg-purple-100',
    textColor: 'text-purple-800',
    dotColor: 'bg-purple-500',
    iconName: 'Loader',
    step: 0
  },
  [STATUS_VALUES.COMPLETED]: {
    label: 'Terminé',
    shortLabel: 'Terminé',
    color: 'green',
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
    dotColor: 'bg-green-500',
    iconName: 'CheckCircle2',
    step: 0
  },

  // Statuts transferts / courses contrats
  'planned': {
    label: 'Planifié',
    shortLabel: 'Planifié',
    color: 'slate',
    bgColor: 'bg-slate-100',
    textColor: 'text-slate-800',
    dotColor: 'bg-slate-500',
    iconName: 'Calendar',
    step: 0
  },
  'en_transit': {
    label: 'En transit',
    shortLabel: 'En transit',
    color: 'amber',
    bgColor: 'bg-amber-100',
    textColor: 'text-amber-800',
    dotColor: 'bg-amber-500',
    iconName: 'Truck',
    step: 0
  },
  'en_cours_de_dechargement': {
    label: 'En déchargement',
    shortLabel: 'Déchargement',
    color: 'purple',
    bgColor: 'bg-purple-100',
    textColor: 'text-purple-800',
    dotColor: 'bg-purple-500',
    iconName: 'Package',
    step: 0
  },
  'loading': {
    label: 'En chargement',
    shortLabel: 'Chargement',
    color: 'orange',
    bgColor: 'bg-orange-100',
    textColor: 'text-orange-800',
    dotColor: 'bg-orange-500',
    iconName: 'Package',
    step: 0
  },
  'delivered': {
    label: 'Livré',
    shortLabel: 'Livré',
    color: 'green',
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
    dotColor: 'bg-green-500',
    iconName: 'CircleCheck',
    step: 0
  },
  'active': {
    label: 'Actif',
    shortLabel: 'Actif',
    color: 'green',
    bgColor: 'bg-green-100',
    textColor: 'text-green-800',
    dotColor: 'bg-green-500',
    iconName: 'CheckCircle',
    step: 0
  },
  'expired': {
    label: 'Expiré',
    shortLabel: 'Expiré',
    color: 'gray',
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-800',
    dotColor: 'bg-gray-500',
    iconName: 'Clock',
    step: 0
  },
  'rejected': {
    label: 'Rejeté',
    shortLabel: 'Rejeté',
    color: 'red',
    bgColor: 'bg-red-100',
    textColor: 'text-red-800',
    dotColor: 'bg-red-500',
    iconName: 'XCircle',
    step: 0
  },
  'draft': {
    label: 'Brouillon',
    shortLabel: 'Brouillon',
    color: 'gray',
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-800',
    dotColor: 'bg-gray-400',
    iconName: 'FileEdit',
    step: 0
  },
  'suspended': {
    label: 'Suspendu',
    shortLabel: 'Suspendu',
    color: 'orange',
    bgColor: 'bg-orange-100',
    textColor: 'text-orange-800',
    dotColor: 'bg-orange-500',
    iconName: 'Ban',
    step: 0
  },
};

// Helper pour obtenir le badge d'un statut
export const getStatusBadge = (status) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG[STATUS_VALUES.PENDING];
  return config;
};

// Helper pour obtenir le label d'un statut
export const getStatusLabel = (status) => {
  const config = STATUS_CONFIG[status];
  return config ? config.label : status;
};

// Liste ordonnée des étapes du workflow V2 (pour la timeline)
export const WORKFLOW_STEPS = [
  STATUS_VALUES.DEMANDE_ENREGISTREE,
  STATUS_VALUES.EN_ATTENTE_DE_DEVIS,
  STATUS_VALUES.EN_ATTENTE_VALIDATION_CLIENT,
  STATUS_VALUES.EN_NEGOCIATION,
  STATUS_VALUES.DEVIS_ACCEPTE,
  STATUS_VALUES.PLANIFIEE,
  STATUS_VALUES.PRETE_AU_CHARGEMENT,
  STATUS_VALUES.EN_COURS_DE_CHARGEMENT,
  STATUS_VALUES.CHARGE_EN_ROUTE,
  STATUS_VALUES.LIVREE,
  STATUS_VALUES.EN_ATTENTE_PAIEMENT,
  STATUS_VALUES.PAYEE,
  STATUS_VALUES.TERMINEE,
];

// Options pour les dropdowns de filtres (ordre workflow + annulée)
// À utiliser dans AdvancedSearchPanel, filtres admin, etc. pour garantir la cohérence des libellés.
export const STATUS_OPTIONS = [
  ...WORKFLOW_STEPS,
  STATUS_VALUES.CANCELLED,
].map((value) => ({
  value,
  label: STATUS_CONFIG[value]?.label || value,
}));
